import { Encounter } from "src/careflow/ph-core/fhir-client/resources";
import { EncounterRepository } from "../../../ports/out/repositories";
import axiosFhirInstance from "../instance/axiosFhirInstance";
import { AxiosFHIRRepository } from "./AxiosFHIRRepository";
import { TokenSource } from "./TokenSource";

export class FHIREncounterRepository extends AxiosFHIRRepository<Encounter> implements EncounterRepository {
  constructor(tokenSource?: TokenSource) {
    super('Encounter', axiosFhirInstance, tokenSource);
  }
}